const isObjectEmpty = (obj: object): boolean =>
  obj &&
  Object.keys(obj).length === 0 &&
  Object.getPrototypeOf(obj) === Object.prototype

export { isObjectEmpty }
